import fetch from './toFetch';

export default {
  /**
   * 提交答题
   * @returns {*|Promise|Promise.<T>|Promise.<U>}
   */
  submit(
      sid,
      answers,
      starttime,
      clientinfo
    ) {
      return fetch('/f/user/reply', {
        sid,
        answers,
        starttime,
        clientinfo
      })
    },

    getFakeToken({
      account,
      project,
      nickname
    }) {
      return fetch('/f/user/gamelogintoken', {
        account,
        project,
        nickname
      })
    },

    logout(sid) {
      return fetch('/f/user/logout', {
        sid
      })
    },

    login(data) {
      return fetch('/f/user/login', data)
    },

    /**
     * 提交答题
     * @returns {*|Promise|Promise.<T>|Promise.<U>}
     */
    getInfo(sid) {
      return fetch(`/f/survey/fview?sid=${sid}`, {}, {
        type: 'GET'
      });
    },
}
